partialContext